// Parsea una fecha que puede venir como Date, 'DD/MM/YYYY' (formato usado en la UI)
// o 'YYYY-MM-DD'/ISO. Se construye siempre con componentes locales (y, m, d) para
// evitar que el constructor nativo Date() interprete 'DD/MM/YYYY' como 'MM/DD/YYYY'
// (formato de EE. UU.) o que un ISO se desfase un día por interpretarse en UTC.
function parseFechaFlexible(f) {
  if (!f && f !== 0) return null;
  if (f instanceof Date) return f;
  const s = String(f).trim();
  const matchDMY = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (matchDMY) {
    const d = parseInt(matchDMY[1], 10);
    const m = parseInt(matchDMY[2], 10) - 1;
    const y = parseInt(matchDMY[3], 10);
    return new Date(y, m, d);
  }
  const matchISO = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
  if (matchISO) {
    const y = parseInt(matchISO[1], 10);
    const m = parseInt(matchISO[2], 10) - 1;
    const d = parseInt(matchISO[3], 10);
    return new Date(y, m, d);
  }
  const d = new Date(s);
  return isNaN(d.getTime()) ? null : d;
}

// Calcula el recargo para una categoría y fecha de pago
// categoriaObj: { categoria, periodicidad, dia_limite, monto_cargo }
// fechaPago: Date o string 'YYYY-MM-DD'
// Nuevo cálculo: requiere categoriaObj, fechaPago y fechaVencimiento
// fechaVencimiento: Date o string 'YYYY-MM-DD'
export function calcularRecargoCategoria(categoriaObj, fechaPago, fechaVencimiento) {
  console.debug('[recargos] calcularRecargoCategoria INICIO', { categoriaObj, fechaPago, fechaVencimiento });
  if (!categoriaObj || !fechaPago || !fechaVencimiento) {
    console.debug('[recargos] FALTA categoriaObj, fechaPago o fechaVencimiento');
    return 0;
  }
  const montoCargoRaw = categoriaObj.monto_cargo !== undefined ? categoriaObj.monto_cargo : categoriaObj.montoCargo;
  const montoCargoNum = Number(montoCargoRaw);
  if (isNaN(montoCargoNum) || montoCargoNum <= 0) {
    console.debug('[recargos] monto_cargo no válido', { montoCargoRaw });
    return 0;
  }
  // Normalizar fechas usando el parser flexible (soporta DD/MM/YYYY e ISO)
  const fechaPagoObj = parseFechaFlexible(fechaPago);
  const fechaVencObj = parseFechaFlexible(fechaVencimiento);
  if (!fechaPagoObj || !fechaVencObj || isNaN(fechaPagoObj.getTime()) || isNaN(fechaVencObj.getTime())) {
    console.debug('[recargos] fechaPago o fechaVencimiento inválida', { fechaPago, fechaVencimiento });
    return 0;
  }
  // Normalizar ambas fechas a las 00:00:00
  const fechaPagoNorm = new Date(fechaPagoObj.getFullYear(), fechaPagoObj.getMonth(), fechaPagoObj.getDate(), 0, 0, 0, 0);
  const fechaVencNorm = new Date(fechaVencObj.getFullYear(), fechaVencObj.getMonth(), fechaVencObj.getDate(), 0, 0, 0, 0);
  // El recargo aplica a partir del día siguiente a la fecha de vencimiento
  const msPorDia = 1000 * 60 * 60 * 24;
  const diffMs = fechaPagoNorm - fechaVencNorm;
  const diasRecargo = Math.floor(diffMs / msPorDia);
  if (diasRecargo < 1) {
    console.debug('[recargos] fechaPago <= fechaVencimiento, sin recargo');
    return 0;
  }
  const resultado = diasRecargo * montoCargoNum;
  console.debug('[recargos] DIAS RECARGO y resultado', { diasRecargo, montoCargoNum, resultado });
  return resultado;
}
